import { Method } from "../Config";
import { ResponseType, Gateway } from "./Gateway";

interface RegionAnalysisQueryParams {
    mapid: string;
}

interface RegionAnalysisReqBody {
    type: number;
    upperRegion: string;
    region?: string;
}

interface RegionAnalysisData {
    count: number;
    region: string;
}

interface RegionAnalysisLegend {
    min: number;
    max: number;
    class: number;
}

interface AccessibilityReqBody {
    vehicle: string;
    point: number[];
}

interface IsochroneReqBody {
    //analysis_type: string;
    //point: string;
    point: number[];
    time_limit: number;
    // distance_limit: number;
    // buckets: number;
    vehicle: string;
    // reverse_flow: boolean;
}

interface RouteReqBody {
    point1: number[];
    point2: number[];
    vehicle: string;
}

interface SlopeReqBody {
    point: number[];
    point2: number[];
}

class AnalysisGateway extends Gateway {
    protected readonly _contextPath = "analysis";
    protected readonly _pathParams?: { [key: string]: string };
    protected readonly _processParams = {
        region: "region",
        accessibility: "accessibility",
        isochrone: "getIsochrone",
        routing: "routing",
        slope: "slope",
    };

    public async reqRegionAnalysisData(query: RegionAnalysisQueryParams, body: RegionAnalysisReqBody): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.region,
            ...query,
        };

        return await this.request(Method.POST, undefined, queryParam, body);
    }

    public async reqAccessibilityData(body: AccessibilityReqBody): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.accessibility,
        };

        return await this.request(Method.POST, undefined, queryParam, body);
    }

    public async reqIsochroneData(body: IsochroneReqBody): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.isochrone,
        };

        return await this.request(Method.POST, undefined, queryParam, body);
    }

    public async reqRouteData(body: RouteReqBody): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.routing,
        };

        return await this.request(Method.POST, undefined, queryParam, body);
    }

    public async reqSlopeData(body: SlopeReqBody): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.slope,
        };

        return await this.request(Method.POST, undefined, queryParam, body);
    }
}

export {
    AnalysisGateway,
    type RegionAnalysisQueryParams,
    type RegionAnalysisReqBody,
    type AccessibilityReqBody,
    type IsochroneReqBody,
    type RegionAnalysisData,
    type RegionAnalysisLegend,
    type RouteReqBody,
    type SlopeReqBody,
};
